import { useCallback, useEffect, useState } from 'react';

export const useVirtualization = <T extends HTMLElement>(rootSelector?: string | null): [(node: T | null) => void, boolean] => {
  const [node, setNode] = useState<T | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const ref = useCallback((node: T | null) => {
    setNode(node);
  }, []);

  useEffect(() => {
    if (!node) return;

    const container = rootSelector ? document.querySelector(rootSelector) : null;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          setIsVisible(entry.isIntersecting);
        }
      },
      {
        root: container,
        threshold: 0,
        rootMargin: '100px',
      },
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [node, rootSelector]);

  return [ref, isVisible];
};
